import { render, staticRenderFns } from "./DescargaView.vue?vue&type=template&id=15a71718&scoped=true&"
import script from "./DescargaView.vue?vue&type=script&lang=ts&"
export * from "./DescargaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a71718",
  null
  
)

export default component.exports